import api from '../common/helpers/apiHelper';
import { IRefReqCandidateForm } from '../common/models/referenceRequest/IRefReqCandidateForm';
import { ICreateRefReq } from '../common/models/referenceRequest/ICreateRefReq';
import { key, getCode } from '../common/helpers/common';
import { IRefReqWorkspace } from '../common/models/workspace/IRefReqWorkspace';

export const getByKey = () => (
  api.get<IRefReqCandidateForm & { workspace: IRefReqWorkspace }>(
    '/candidate-api/reference-request', { key, code: getCode() }
  )
);

export const createRefReq = (data: ICreateRefReq) => (
  api.post('/api/reference-requests', data)
);
